export const createContestsEditionsJudgesRequests = (client) => ({
    listContestsEditionJudges: async (params) => {
        const { data, meta, links } = await client.api.get("contests_edition_judges", {
            params: params,
        });
        return { data, meta, links };
    },
    findContestsEditionJudge: async (params) => {
        const { data } = await client.api.get(`contests_edition_judges/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    contestsEditionJudgeStats: async (params) => {
        const { data } = await client.api.request({
            type: "contests_edition_judge",
            method: "GET",
            url: "/contests_edition_judges/statistics",
            params: params,
        });
        return { data };
    },
    createContestsEditionJudge: async (payload) => {
        const { data } = await client.api.create("contests_edition_judges", payload);
        return { data };
    },
    inviteContestsEditionJudge: async (payload) => {
        const { data } = await client.api.request({
            type: "contests_edition_judges",
            url: `/contests_edition_judges/invite`,
            method: "POST",
            body: payload,
        });
        return { data };
    },
    joinContestsEditionByCode: async (payload) => {
        const { data } = await client.api.request({
            type: "contests_edition_judges",
            url: `/contests_edition_judges/join_by_code`,
            method: "POST",
            body: payload,
        });
        return { data };
    },
    approveContestsEditionJudge: async (payload) => {
        const { data } = await client.api.request({
            type: "contests_edition_judges",
            url: `/contests_edition_judges/${payload?.id}/approve`,
            method: "PATCH",
            body: payload,
        });
        return { data };
    },
    rejectContestsEditionJudge: async (payload) => {
        const { data } = await client.api.request({
            type: "contests_edition_judges",
            url: `/contests_edition_judges/${payload?.id}/reject`,
            method: "PATCH",
            body: payload,
        });
        return { data };
    },
    toggleJudgePresence: async (payload) => {
        const { data } = await client.api.request({
            type: "contests_edition_judges",
            url: `/contests_edition_judges/${payload?.id}/presence`,
            method: "PATCH",
            body: payload,
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map